import { ClaimsRequireTypeEnum, type UserPermissionModel } from './../../models/user.models';
import { autoinject } from "aurelia-dependency-injection";
import * as Enumerable from "linq";

@autoinject
export class UserClaimsService {

    private _claims: { [permission: string]: UserPermissionModel } = {};
    private _claimIds: { [id: number]: UserPermissionModel } = {};

    public setUserClaims(claims: UserPermissionModel[]) {
        this._claims = {};
        if (claims) {
            claims.forEach(claim => {
                this._claims[claim.permission] = claim;
                this._claimIds[claim.permissionId] = claim;
            })
        }
    }

    public hasPermission(claim: string): boolean {
        if (this._claims) {
            if (claim) {
                return claim in this._claims;
            }
        }// TODO: else get and wait for data?
        return false;
    }
    
    public hasPermissionById(claimId: number): boolean {
        if (this._claimIds) {
            if (claimId) {
                return claimId in this._claimIds;
            }
        }// TODO: else get and wait for data?
        return false;
    }

    public hasPermissions(claims: string[] | (() => string[]), claimsRequireType?: ClaimsRequireTypeEnum): boolean {
        if (typeof claims == "function") {
            claims = claims();
        }
        if (!claims || claims.length == 0 || (claims && claims.every(x => !x)))
            return true;

        //if claim require type is require any then, true if user has any of the permissions in list
        if (claimsRequireType && claimsRequireType == 2) {
            return Enumerable.from(claims).any(x => this.hasPermission(x));
        }

        //if no claim require type then all claims in list are required 

        let hasPermission: boolean = true;

        for (const permission of claims) {
            if (hasPermission && this.hasPermission(permission)) {
                hasPermission = true;
            }
            else {
                hasPermission = false;
            }
        }
        return hasPermission;
    }
}
